import { apiRequest } from "@/services/api-client";
import {
  UpdatePokemonNameInput,
  UpdatePokemonNameOutput,
  WebAppRoutes,
} from "types/web-app";

export const updatePokemonName = async (
  input: UpdatePokemonNameInput,
): Promise<{ ok: boolean; message?: string }> => {
  const result = await apiRequest<UpdatePokemonNameOutput>(
    "/" + WebAppRoutes.UPDATE_POKEMON_NAME,
    {
      method: "POST",
      body: JSON.stringify(input),
    },
  );

  if (!result.ok) {
    return {
      ok: false,
      message: result.message || "Failed to update Pokemon name",
    };
  }

  return { ok: true };
};
